import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { queryKeys } from "@/core/data-fetching/queryKeys";

import { usageService, type UsageRangeParams } from "../api/usage.service";

/**
 * Consumo por empresa no período.
 *
 * `keepPreviousData` evita a tela piscar em branco ao trocar o período — os
 * números antigos ficam visíveis até os novos chegarem, o que é o comportamento
 * certo para um painel que se compara consigo mesmo.
 *
 * `staleTime` de 2 min porque a agregação varre `messages` — 736 ms medidos em
 * produção. Barato o bastante para consultar ao vivo, caro o bastante para não
 * repetir a cada foco de janela.
 */
export function useUsageByCompanyQuery(params: UsageRangeParams) {
  // A chave ignora `companyId` de propósito: a resposta é sempre a lista
  // completa, e trocar de empresa não deve refazer a consulta cara.
  const escopo = { from: params.from, to: params.to };
  return useQuery({
    queryKey: queryKeys.usage.byCompany(escopo),
    queryFn: () => usageService.byCompany(escopo),
    placeholderData: keepPreviousData,
    staleTime: 2 * 60 * 1000,
  });
}

/** Série diária para o gráfico. Sem `companyId`, é o total da plataforma. */
export function useUsageSeriesQuery(params: UsageRangeParams) {
  return useQuery({
    queryKey: queryKeys.usage.series(params),
    queryFn: () => usageService.series(params),
    placeholderData: keepPreviousData,
    staleTime: 2 * 60 * 1000,
  });
}
